import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import { LangProvider } from "@/lib/i18n";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Auth from "@/pages/Auth";
import BookConsult from "@/pages/BookConsult";
import Chat from "@/pages/Chat";
import EBooks from "@/pages/EBooks";
import Content from "@/pages/Content";
import Trackers from "@/pages/Trackers";
import ParentDashboard from "@/pages/ParentDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import { About, Contact, ParentingTips } from "@/pages/StaticPages";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LangProvider>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Auth mode="login" />} />
                <Route path="/register" element={<Auth mode="register" />} />
                <Route path="/book" element={<BookConsult />} />
                <Route path="/chat/:id" element={<Chat />} />
                <Route path="/ebooks" element={<EBooks />} />
                <Route path="/content" element={<Content />} />
                <Route path="/tips" element={<ParentingTips />} />
                <Route path="/trackers" element={<Trackers />} />
                <Route path="/dashboard" element={<ParentDashboard />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </Layout>
          </LangProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
